import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { AssetAnalysisChartModule } from '../assets/ui/asset-analysis-chart.module';
import { LastSearchService } from '../shared/services/lastSearchService';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DashboardPageComponent } from './feature/dashboard-page/dashboard-page.component';
import { DASHBOARD_STATES } from './dashboard.states';
import { DashboardAccessService } from './data-access/dashboard-access.service';
import { DashboardContextService } from './data-access/dashboard-context.service';
import { DashboardLayoutService } from './data-access/dashboard-layout.service';
import { LastSearchDataService } from './data-access/widgets/last-search-data.service';
import { MessageOfTheDayDataService } from './data-access/widgets/message-of-the-day-data.service';
import { ProjectStatsDataService } from './data-access/widgets/project-stats-data.service';
import { ProjectSuggestionDataService } from './data-access/widgets/project-suggestion-data.service';
import { RecentlyAddedProjectsDataService } from './data-access/widgets/recently-added-projects-data.service';
import { RecentlyAddedAssetsDataService } from './data-access/widgets/recently-added-assets-data.service';
import { RecentlyAwardedContractsDataService } from './data-access/widgets/recently-awarded-contracts-data.service';
import { SavedSearchesDataService } from './data-access/widgets/saved-searches-data.service';
import { DashboardCardComponent } from './ui/shared/dashboard-card.component';
import { AssetAnalysisChartWidgetComponent } from './ui/widgets/asset-analysis-chart-widget.component';
import { MessageOfTheDayWidgetComponent } from './ui/widgets/message-of-the-day-widget.component';
import { NewSearchWidgetComponent } from './ui/widgets/new-search-widget.component';
import { NumberOfProjectsChartWidgetComponent } from './ui/widgets/number-of-projects-chart-widget.component';
import { QuickFindProjectWidgetComponent } from './ui/widgets/quick-find-project-widget.component';
import { RecentlyAddedAssetsWidgetComponent } from './ui/widgets/recently-added-assets-widget.component';
import { RecentlyAddedProjectsWidgetComponent } from './ui/widgets/recently-added-projects-widget.component';
import { RecentlyAwardedContractsWidgetComponent } from './ui/widgets/recently-awarded-contracts-widget.component';
import { RepeatLastSearchWidgetComponent } from './ui/widgets/repeat-last-search-widget.component';
import { SavedSearchesWidgetComponent } from './ui/widgets/saved-searches-widget.component';

@NgModule({
  declarations: [
    DashboardPageComponent,
    DashboardCardComponent,
    NewSearchWidgetComponent,
    RepeatLastSearchWidgetComponent,
    SavedSearchesWidgetComponent,
    RecentlyAddedProjectsWidgetComponent,
    RecentlyAwardedContractsWidgetComponent,
    QuickFindProjectWidgetComponent,
    NumberOfProjectsChartWidgetComponent,
    AssetAnalysisChartWidgetComponent,
    RecentlyAddedAssetsWidgetComponent,
    MessageOfTheDayWidgetComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UIRouterModule.forChild({ states: DASHBOARD_STATES }),
    MatCardModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    DragDropModule,
    NgxChartsModule,
    AssetAnalysisChartModule
  ],
  providers: [
    DashboardLayoutService,
    DashboardAccessService,
    DashboardContextService,
    SavedSearchesDataService,
    RecentlyAddedProjectsDataService,
    RecentlyAddedAssetsDataService,
    RecentlyAwardedContractsDataService,
    ProjectSuggestionDataService,
    ProjectStatsDataService,
    MessageOfTheDayDataService,
    LastSearchDataService,
    LastSearchService
  ]
})
export class DashboardModule { }
